/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Projects_Bulk_Unarchive_SuccessInputs */



/**
* | output |
* | --- |
* | "{count} project(s) unarchived" |
*
* @param {Projects_Bulk_Unarchive_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_bulk_unarchive_success = /** @type {((inputs: Projects_Bulk_Unarchive_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Bulk_Unarchive_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Projekt(e) wiederhergestellt`)
	return /** @type {LocalizedString} */ (`${i?.count} project(s) unarchived`)
});